import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { api_getContentPageByCode, api_subscribeToNewsletter } from '~/backend/api_calls';
import { notifyError, notifyInfo } from './ToastMessages';

export default function NewsletterArea() {
	const { t } = useTranslation();
	const [newsletterEmail, setNewsletterEmail] = useState('');
	const [newsletterConsent, setNewsletterConsent] = useState(false);
	const [termsAndConditionsLinks, setTermsAndConditionsLinks] = useState('');

	useEffect(() => {
		api_getContentPageByCode('terms_and_conditions_links').then(json => setTermsAndConditionsLinks(json));
	}, []);

	const handleFormSubmit = e => {
		e.preventDefault();

		if (newsletterEmail == null || newsletterEmail.length == 0) {
			notifyError(t('complete_all_fields'));
			return;
		}

		if (!newsletterConsent) {
			notifyError('You have to accept the Terms and Conditions');
			return;
		}

		api_subscribeToNewsletter(newsletterEmail)
			.then(json => notifyInfo(json))
			.catch(json => notifyError(json));
	};

	return (
		<div className="newsletter-area">
			<div className="social-links">
				<a href="https://www.facebook.com/undergroundshop.gr" title="Facebook" target="_blank" rel="noopener noreferrer">
					<svg id="fb" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
						<rect id="Rectangle_161019" data-name="Rectangle 161019" width="30" height="30" fill="#fff" opacity="0" />
						<g id="Icon_awesome-facebook-f" data-name="Icon awesome-facebook-f" transform="translate(10 6)">
							<path
								id="Icon_awesome-facebook-f-2"
								data-name="Icon awesome-facebook-f"
								d="M10.954,10.5l.519-3.379H8.231V4.931a1.69,1.69,0,0,1,1.905-1.826H11.61V.228A17.976,17.976,0,0,0,8.993,0C6.323,0,4.578,1.618,4.578,4.548V7.124H1.609V10.5H4.578v8.169H8.231V10.5Z"
								transform="translate(-1.609)"
								fill="#000"
							/>
						</g>
					</svg>
				</a>
				<a href="https://www.instagram.com/undergroundshop.gr" title="Instagram" target="_blank" rel="noopener noreferrer">
					<svg id="instagram" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
						<rect id="Rectangle_161020" data-name="Rectangle 161020" width="30" height="30" fill="#fff" opacity="0" />
						<g id="Icon_simple-instagram" data-name="Icon simple-instagram" transform="translate(5.591 6)">
							<path
								id="Icon_simple-instagram-2"
								data-name="Icon simple-instagram"
								d="M9.336,0C6.8,0,6.483.012,5.487.056A6.884,6.884,0,0,0,3.221.49,4.572,4.572,0,0,0,1.567,1.567,4.555,4.555,0,0,0,.49,3.221,6.864,6.864,0,0,0,.056,5.487C.009,6.483,0,6.8,0,9.336s.012,2.853.056,3.849A6.888,6.888,0,0,0,.49,15.451,4.578,4.578,0,0,0,1.567,17.1a4.565,4.565,0,0,0,1.654,1.077,6.893,6.893,0,0,0,2.266.434c1,.047,1.312.056,3.849.056s2.853-.012,3.849-.056a6.909,6.909,0,0,0,2.266-.434,4.771,4.771,0,0,0,2.731-2.731,6.888,6.888,0,0,0,.434-2.266c.047-1,.056-1.312.056-3.849s-.012-2.853-.056-3.849a6.9,6.9,0,0,0-.434-2.266A4.582,4.582,0,0,0,17.1,1.567,4.549,4.549,0,0,0,15.451.49,6.868,6.868,0,0,0,13.185.056C12.189.009,11.872,0,9.336,0Zm0,1.68c2.492,0,2.789.012,3.773.055a5.144,5.144,0,0,1,1.733.323A3.072,3.072,0,0,1,16.614,3.83a5.155,5.155,0,0,1,.321,1.733c.044.985.054,1.281.054,3.773s-.012,2.789-.058,3.773a5.254,5.254,0,0,1-.328,1.733,2.964,2.964,0,0,1-.7,1.075,2.913,2.913,0,0,1-1.074.7,5.192,5.192,0,0,1-1.739.321c-.991.044-1.283.054-3.78.054s-2.79-.012-3.78-.058a5.294,5.294,0,0,1-1.74-.328,2.891,2.891,0,0,1-1.073-.7,2.835,2.835,0,0,1-.7-1.074,5.3,5.3,0,0,1-.327-1.739c-.035-.98-.047-1.283-.047-3.769s.012-2.79.047-3.782A5.292,5.292,0,0,1,2.02,3.8a2.767,2.767,0,0,1,.7-1.074,2.761,2.761,0,0,1,1.073-.7A5.167,5.167,0,0,1,5.521,1.7c.992-.035,1.284-.047,3.78-.047l.035.023Zm0,2.861A4.794,4.794,0,1,0,14.13,9.336,4.794,4.794,0,0,0,9.336,4.542Zm0,7.906a3.112,3.112,0,1,1,3.112-3.112A3.111,3.111,0,0,1,9.336,12.448Zm6.1-8.095a1.12,1.12,0,1,1-1.12-1.12A1.121,1.121,0,0,1,15.44,4.353Z"
								transform="translate(0)"
								fill="#000"
							/>
						</g>
					</svg>
				</a>
				<a href="http://www.youtube.com/@undergroundshopskg" title="Youtube" target="_blank" rel="noopener noreferrer">
					<svg id="youtube" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
						<rect id="Rectangle_161022" data-name="Rectangle 161022" width="30" height="30" fill="#fff" opacity="0" />
						<path
							id="Icon_zocial-youtube"
							data-name="Icon zocial-youtube"
							d="M2.681,15.063q0-1.163.129-3.492A2.744,2.744,0,0,1,5.5,8.92q2.155-.108,6.487-.108t6.488.108a2.746,2.746,0,0,1,2.694,2.651q.106,1.94.108,3.492t-.108,3.492a2.744,2.744,0,0,1-2.694,2.651q-2.156.107-6.488.108T5.5,21.206a2.744,2.744,0,0,1-2.693-2.652Q2.681,16.228,2.681,15.063Zm1.444-3.038H5.44v7.027H6.711V12.024H8.026V10.839h-3.9Zm1.4-13H6.819L7.638,2.3h.086L8.5-.972H9.793L8.8,2.218q-.5,1.573-.5,1.616V7.24H7.035V3.985a3.584,3.584,0,0,0-.119-.55c-.05-.165-.115-.356-.194-.571s-.14-.4-.183-.539ZM8.026,18.1q0,1.035.776,1.035a1.742,1.742,0,0,0,1.315-.754v.668h1.121V12.994H10.117v4.612q-.453.453-.668.453c-.2,0-.3-.137-.3-.41V12.995H8.026Zm1.7-12.393V2.563A1.4,1.4,0,0,1,10.2,1.431a1.81,1.81,0,0,1,1.207-.4,1.579,1.579,0,0,1,1.152.431A1.522,1.522,0,0,1,13,2.606V5.731a1.668,1.668,0,0,1-.431,1.218,1.61,1.61,0,0,1-1.207.442,1.574,1.574,0,0,1-1.2-.463A1.7,1.7,0,0,1,9.729,5.709Zm1.164.151q0,.5.474.5.5,0,.5-.539V2.52a.408.408,0,0,0-.152-.323.513.513,0,0,0-.345-.129.5.5,0,0,0-.334.119.388.388,0,0,0-.14.313V5.86Zm1.444,13.19h1.142V18.6a1.327,1.327,0,0,0,1.078.539q1.012,0,1.013-1.336V14.438q0-1.53-1.1-1.53a1.272,1.272,0,0,0-.991.581V10.839H12.337v8.212Zm1.142-1.142V14.115a.684.684,0,0,1,.474-.238q.474,0,.474.6v3.19q0,.517-.41.517A.693.693,0,0,1,13.479,17.908Zm.5-11.617V1.183H15.1V5.817q0,.409.3.41.28,0,.668-.453V1.183h1.121V7.24H16.065V6.572a1.743,1.743,0,0,1-1.315.754Q13.975,7.326,13.975,6.291Zm2.457,11.057a2.134,2.134,0,0,0,.41,1.347,1.459,1.459,0,0,0,1.229.528q1.681,0,1.68-1.875V16.9H18.588c0,.029,0,.126.011.291a1.714,1.714,0,0,1-.011.356c-.014.071-.033.169-.054.292a.379.379,0,0,1-.141.258.517.517,0,0,1-.3.075q-.5,0-.5-.862V16.163h2.155V14.611a1.946,1.946,0,0,0-.4-1.293,1.5,1.5,0,0,0-1.218-.473,1.615,1.615,0,0,0-1.239.5,1.79,1.79,0,0,0-.463,1.272ZM17.6,15.214v-.647q0-.668.5-.668t.5.668v.647Z"
							transform="translate(3.319 4.972)"
						/>
					</svg>
				</a>
				<a href="https://www.tiktok.com/@undergroundshop.gr " title="Tiktok" target="_blank" rel="noopener noreferrer">
					<svg id="tiktok" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
						<rect id="Rectangle_161020" data-name="Rectangle 161020" width="30" height="30" fill="#fff" opacity="0" />
						<path
							id="Path_38064"
							data-name="Path 38064"
							d="M353.872,433.46c0-.083,0-.086-.089-.085a3.915,3.915,0,0,1-.622-.054c-.747-.113-3.17-1.384-3.58-3.463a6.34,6.34,0,0,1-.1-.776c0-.1,0-.1-.1-.1h-2.912c-.191,0-.164-.024-.164.168q0,6.168,0,12.337a2.665,2.665,0,0,1-3.207,2.638,3.58,3.58,0,0,1-.625-.206l-.049-.045c-.069-.058-.144-.1-.218-.156a2.624,2.624,0,0,1,.592-4.679,2.357,2.357,0,0,1,.945-.14,2.78,2.78,0,0,1,.618.1c.07.02.108,0,.111-.079,0-.026,0-.052,0-.078,0-.738-.027-2.351-.031-2.354,0-.213,0-.425.005-.637,0-.062-.029-.072-.081-.078a6,6,0,0,0-1.15-.026,5.818,5.818,0,0,0-4.88,3.414,5.825,5.825,0,0,0-.24,4.125,5.784,5.784,0,0,0,1.969,2.831,1.379,1.379,0,0,0,.3.208h0l.144.128a3.054,3.054,0,0,0,.486.3,5.876,5.876,0,0,0,7.113-1.428,5.72,5.72,0,0,0,1.4-3.8c.012-2.048,0-4.1,0-6.144,0-.049-.028-.118.026-.143s.084.037.124.063a7.543,7.543,0,0,0,2.474,1.066,6.993,6.993,0,0,0,1.574.19c.168,0,.19-.009.191-.175C353.91,435.641,353.871,433.653,353.872,433.46Z"
							transform="translate(-330.939 -423.246)"
						/>
					</svg>
				</a>
				{/*<a href="#" title="Youtube" target="_blank" rel="noopener noreferrer">
                    <svg id="youtube" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
                        <rect id="Rectangle_161022" data-name="Rectangle 161022" width="30" height="30" fill="#fff" opacity="0" />
                        <path id="Icon_awesome-youtube" data-name="Icon awesome-youtube" d="M22.877,6.953a2.8,2.8,0,0,0-1.971-1.984C19.168,4.5,12.2,4.5,12.2,4.5s-6.971,0-8.71.469A2.8,2.8,0,0,0,1.516,6.953a29.385,29.385,0,0,0-.466,5.4,29.385,29.385,0,0,0,.466,5.4,2.759,2.759,0,0,0,1.971,1.952c1.739.469,8.71.469,8.71.469s6.971,0,8.71-.469a2.759,2.759,0,0,0,1.971-1.952,29.385,29.385,0,0,0,.466-5.4,29.385,29.385,0,0,0-.466-5.4ZM9.917,15.668V9.039l5.827,3.315L9.917,15.668Z" transform="translate(2.95 2.5)" fill="#ababab" />
                    </svg>
                </a>*/}
			</div>
			<div className="newsletter-box">
				<p className="newsletter-text" dangerouslySetInnerHTML={{ __html: t('footer_newsletter_description') }}></p>

				<div className="gender-section">
					<label htmlFor="female" className="form-control">
						<input type="radio" value="Female" name="gender" id="female" /> {t('footer_newsletter_female')}
					</label>

					<label htmlFor="male" className="form-control">
						<input type="radio" value="Male" name="gender" id="male" /> {t('footer_newsletter_male')}
					</label>
				</div>

				<form className="subscription" onSubmit={handleFormSubmit}>
					<input
						key="subscription_newsletter"
						className="add-email"
						type="email"
						name="guest-email"
						placeholder={t('footer_newsletter_input')}
						value={newsletterEmail}
						onChange={e => setNewsletterEmail(e.target.value)}
					/>

					<button className="submit-email" type="submit">
						<span className="before-submit">{t('footer_newsletter_button')}</span>
					</button>
				</form>

				<div className="checkbox-area">
					<label className="acceptance">
						<input type="checkbox" name="accept-terms" checked={newsletterConsent} onChange={e => setNewsletterConsent(e.target.checked)} />
						<span className="input-label">
							{/* <span
								dangerouslySetInnerHTML={{
									__html: termsAndConditionsLinks.bd
								}}></span> */}
							<Link to={'/pages/terms-of-use'}>{t('accept_terms_of_use')}</Link>
						</span>
					</label>
				</div>
			</div>
		</div>
	);
}
